<div class="container">
  <nav class="navbar navbar-expand-lg navbar-expand-md navbar-expand-sm navbar-expand-xs navbar-light fixed-top">
    <img src="assets/Images/CDM-03.png" alt="Logo" class="navbar-logo ms-2" />
    <div class="ms-5"></div>
    <button class="navbar-toggler ms-5" type="button" (click)="toggleSidenav()"
      style="display: flex;">
      <i class="bi" [ngClass]="isSidenavOpen ? 'bi-arrow-bar-left' : 'bi-arrow-bar-right'"></i>
    </button>
    <div class="container-fluid head">

      <span class="text mx-auto">Welcome
        <span style="color:#FFCE18;">{{
          getUserTypeName(loginData?.userType)
          }}</span></span>

      <span class="logout"><a (click)="logout()"><i class="bi bi-box-arrow-right"></i></a></span>
    </div>
  </nav>
</div>